
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"mask0_2463_10666","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"17","height":"16"}},[_c('path',{attrs:{"d":"M16.5 0H0.5V16H16.5V0Z","fill":"white"}})]),_c('g',{attrs:{"mask":"url(#mask0_2463_10666)"}},[_c('path',{attrs:{"d":"M8.50977 14.2334V9.63965","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.104 12.9253L9.43555 9.25684","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.58445 9.25684L3.91602 12.9253","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.82422 6.54004V8.3316C9.82422 9.05348 9.23359 9.6441 8.51172 9.6441C7.78984 9.6441 7.19922 9.05348 7.19922 8.3316V7.24879","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.7671 6.13242L4.06307 7.76486L3.51904 5.19689L11.223 3.56445L11.7671 6.13242Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.79148 6.48242L2.48242 6.7547","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.3234 7.14526L12.0395 7.41729L10.9512 2.28133L12.2352 2.00923C12.9443 1.85901 13.641 2.31205 13.7913 3.02123L14.3354 5.58923C14.4856 6.29833 14.0326 6.99501 13.3234 7.14526Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    